import { MutableRefObject, useEffect, useRef } from 'react'

export type Position = { x: number; y: number }

type Params = {
  nodeRef: MutableRefObject<HTMLElement | null>
  basePosition: Position
  onPositionClamp: (pos: Position) => void
}

export const useClampPositionOnResize = ({
  nodeRef,
  basePosition,
  onPositionClamp
}: Params) => {
  const basePositionRef = useRef(basePosition)
  basePositionRef.current = basePosition

  useEffect(() => {
    const handleResize = () => {
      if (!nodeRef.current) return

      const { offsetWidth, offsetHeight } = nodeRef.current
      const maxX = window.innerWidth - offsetWidth
      const maxY = window.innerHeight - offsetHeight
      const { x, y } = basePositionRef.current
      const clampedX = Math.max(0, Math.min(maxX, x))
      const clampedY = Math.max(0, Math.min(maxY, y))

      if (clampedX !== x || clampedY !== y) {
        onPositionClamp({ x: clampedX, y: clampedY })
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [nodeRef, onPositionClamp])
}
